import { useEffect, useRef } from 'react';



export function infiniteScroll(getMoreContent:any, infiniteScrollFetchCondition: boolean, root: Element | Document | null | undefined = null) {
    const infiniteScrollRef = useRef(null);

    useEffect(() => {
        if (getMoreContent) {
            const observer = new IntersectionObserver(
                (entries) => {
                    if (entries[0].isIntersecting && infiniteScrollFetchCondition) {
                        getMoreContent();
                    }
                },
                {root, rootMargin: "20px", threshold: 1.0}
            );

            if (infiniteScrollRef.current) {
                observer.observe(infiniteScrollRef.current);
            }

            return () => {
                if (infiniteScrollRef.current) {
                    observer.unobserve(infiniteScrollRef.current);
                }
            };
        }
    }, [getMoreContent]);

    return infiniteScrollRef;
};